import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestOperacaoAfericaoVeiculo({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'afericaoveiculo', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deleteOperacaoAfericaoVeiculo({ payload }) {
  try {
    const { veic_placa, params } = payload;

    yield call(api.delete, `afericaoveiculo/${veic_placa}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { operacaoafericaoveiculo, params } = payload;

    yield call(api.post, 'afericaoveiculo', operacaoafericaoveiculo);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/veiculomanutencaoafericao');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { veic_placa } = payload;

    const { data } = yield call(api.get, `afericaoveiculo/${veic_placa}`);

    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { operacaoafericaoveiculo, params } = payload;

    yield call(api.put, 'afericaoveiculo', operacaoafericaoveiculo);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/veiculomanutencaoafericao');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;

    const response = yield call(api.get, 'afericaoveiculo', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest(
    '@operacaoafericaoveiculo/AFERICAOVEICULO_IN_REQUEST',
    requestOperacaoAfericaoVeiculo
  ),
  takeLatest(
    '@operacaoafericaoveiculo/DELETE_AFERICAOVEICULO',
    deleteOperacaoAfericaoVeiculo
  ),
  takeLatest(
    '@operacaoafericaoveiculo/SUCCESS_REMOVE',
    requestOperacaoAfericaoVeiculo
  ),
  takeLatest('@operacaoafericaoveiculo/STORE_AFERICAOVEICULO', store),
  takeLatest('@operacaoafericaoveiculo/FIND_AFERICAOVEICULO', find),
  takeLatest('@operacaoafericaoveiculo/UPDATE_AFERICAOVEICULO', update),
  takeLatest('@operacaoafericaoveiculo/RECORD_FILTERING', applyedFilters),
]);
